import { IconButton, Paper, Stack } from '@mui/material';
import { useMap } from 'react-map-gl';
import RoutingParameters from '../RoutingParameters/RoutingParameters';
import LocationSearchInput from './LocationSearchInput';
import DeleteIcon from "@mui/icons-material/Delete";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { useRouteResponse, useRouteStoreActions } from "../../stores/RouteStore";
import { useFromAddress } from '../../stores/RouteLocationStore';
import { useToAddress } from '../../stores/RouteLocationStore';
import { useRouteLocationActions } from '../../stores/RouteLocationStore';

export interface IRoutingMenuProps {

}

function RouteButtons() {

    const route = useRouteResponse();
    const { setRouteResponse, setSelectedRouteIndex, setRouteDrawerOpen } = useRouteStoreActions();
    const fromAddress = useFromAddress();
    const toAddress = useToAddress();
    const {setFrom, setTo, clearFrom, clearTo, clearViaPoints } = useRouteLocationActions();

    const revertRoute = () => {
        if (toAddress && fromAddress) {
            setFrom(toAddress);
            setTo(fromAddress);
        }
    }

    const deleteRoute = () => {
        setRouteResponse(null);
        setSelectedRouteIndex(0);
        clearFrom();
        clearTo();
        clearViaPoints();
        setRouteDrawerOpen(false);
    }


    return (
        <Stack direction="row" spacing={0} style={{ paddingTop: "5px", paddingBottom: "5px" }}>
            <IconButton size="small" style={{ fontSize: 15 }} disabled={route === null} onClick={revertRoute}>Snu rute
                <SwapVertIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" style={{ fontSize: 15 }} disabled={route === null} onClick={deleteRoute}>Slett rute
                <DeleteIcon fontSize="small" />
            </IconButton>
        </Stack>
    )
}

export default function SearchMenu(props: IRoutingMenuProps) {
    const { current: map } = useMap();

    const PlacePointerOnMapWithZoom = () => {
        if (map !== undefined) {
            map.flyTo({ center: [10.5226, 59.8894] });
        }
    };


    return (
        <Paper style={{ zIndex: "10000", padding: "5px", overflowY: "auto" }} id='searchMenuPaper'>
            <LocationSearchInput />
            <RouteButtons />
            <RoutingParameters />            
        </Paper>
    );
}
